class DocumentChecklist {
    id = 0;
    maritime_object_id = null;
    additional_info = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default DocumentChecklist;
